import React from 'react';
import PropTypes from 'prop-types';
import {View, Text, StyleSheet} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import {JourneyDetailsCardForBJ} from '../Common/JourneyDetailsCard';
import TouchableRipple from '@mmt/legacy-commons/Common/Components/TouchableRipple';
import Card from '@mmt/legacy-commons/Common/Components/Card';
import { _label } from '../../vernacular/AppLanguage';
import {fontStyle, getLineHeight} from "../../vernacular/VernacularUtils";

function TrainCard(props) {
  const {
    seatsAvailability,
    availabilityType,
    prettyPrintingAvailabilityStatus,
    journeyClass,
    journeyQuota,
    totalFare,
    trainInfo
  } = props.item;

  const trainCardContainerStyle = {
    flex: 1,
    marginHorizontal: 16,
    marginVertical: 23,
    borderColor: '#e7e7e7',
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 8,
    paddingTop: 20,
    paddingBottom: 10
  };

  return (
    <Card style={trainCardContainerStyle} elevation={3}>
      <JourneyDetailsCardForBJ
        trainData={trainInfo}
        seatsAvailability={seatsAvailability}
        availabilityType={availabilityType}
        prettyPrintingAvailabilityStatus={prettyPrintingAvailabilityStatus}
        journeyClass={journeyClass}
        journeyQuota={journeyQuota}
        totalFare={totalFare}
      />
      <TouchableRipple onPress={() => props.bookBreakJourneyClicked()}>
        <View style={styles.bookButtonContainer}>
          <Text style={[styles.bookButton, fontStyle("black"), getLineHeight(16)]}>{_label("book", { uppercase: true })}</Text>
        </View>
      </TouchableRipple>
      <LinearGradient colors={['#4a4a4a', '#000000']} style={styles.trainHeading}>
        <Text style={[styles.headingText, fontStyle("bold"), getLineHeight(12)]}>{_label("train", {uppercase: true}, { num: (props.index + 1).toString()})}</Text>
      </LinearGradient>
    </Card>
  );
}

TrainCard.propTypes = {
  bookBreakJourneyClicked: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired
};

const styles = StyleSheet.create({
  trainHeading: {
    position: 'absolute',
    top: -10,
    left: 10,
    borderRadius: 8.5,
    width: 62,
    height: 17,
    alignItems: 'center',
    justifyContent: 'center'
  },
  headingText: {
    color: 'white',
    fontSize: 12
  },
  bookButtonContainer: {
    height: 44,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: '#008cff',
    marginTop: 15
  },
  bookButton: {
    fontSize: 16,
    lineHeight: 20,
    color: '#ffffff'
  }
});

export default TrainCard;
